import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M3 3.7a.7.7 0 0 1 .7-.7h16.6a.7.7 0 0 1 .7.7v16.6a.7.7 0 0 1-.7.7H3.7a.7.7 0 0 1-.7-.7V3.7Zm1.4.7v2.75h15.2V4.4H4.4Zm15.2 4.15H4.4V19.6h15.2V8.55Zm-4.358 2.31a.7.7 0 0 1 .415.64v4.685h.867a.7.7 0 1 1 0 1.4h-3.14a.7.7 0 0 1 0-1.4h.873v-3.11l-.404.366a.7.7 0 0 1-.938-1.04l1.573-1.42a.7.7 0 0 1 .754-.12Zm-5.9 1.34c-.307 0-.577.209-.67.53a.7.7 0 0 1-1.344-.39c.25-.864 1.028-1.54 2.015-1.54a2.12 2.12 0 0 1 2.122 2.121c0 .485-.175.929-.466 1.272.29.343.466.787.466 1.271a2.12 2.12 0 0 1-2.122 2.12c-.987 0-1.765-.674-2.015-1.538a.7.7 0 0 1 1.344-.39c.093.321.363.529.67.529a.72.72 0 0 0 .723-.72.573.573 0 0 0-.573-.572.7.7 0 1 1 0-1.4.573.573 0 0 0 .573-.572.72.72 0 0 0-.722-.72Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
